<template>
  <a
    v-if="campaign"
    :href="campaign.click_url"
    class="d-block text-decoration-none alert mb-0 border-0 text-center"
    :style="`background-color: ${campaign.bgcolor} !important; color: ${campaign.textcolor} !important;`"
    target="_blank"
    v-html="campaign.headline"
  ></a>
</template>

<script>
import { getCampaigns } from '@/api'

export default {
  props: {
    slotName: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      campaign: null
    }
  },
  computed: {
    //
  },
  async mounted () {
    let response = await getCampaigns(this.slotName, null, 1)
    if (response.data.data) {
      this.campaign = response.data.data[0]
    }
  }
}
</script>